import { styled, DialogTitle, Typography, Dialog, dialogClasses } from "@mui/material";
import { css } from "@emotion/react";
import { HANDLE_CLASS } from "./dialog.constants.js";
const HeaderTextWrapper = styled("span")`
  width: 100%;
`;
const Wrapper = styled("div")`
  ${({ width }) => width && css`
      width: ${width}px;
    `}
`;
const StyledDialogTitle = styled(DialogTitle, {
  shouldForwardProp: (prop) => prop !== "colorVariant" && prop !== "draggable"
})(({ theme, draggable, colorVariant }) => {
  let colorStyles = "";
  if (draggable) {
    colorStyles += `
      &.${HANDLE_CLASS} {
        cursor: grab;
      }
    `;
  }
  switch (colorVariant) {
    case "grey": {
      colorStyles += `
        &&& {
          background-color: ${theme.palette.grey[300]};
          color: ${theme.palette.grey[800]};
        }
      `;
      break;
    }
    case "warning": {
      colorStyles += `
        &&& {
          background-color: ${theme.palette.secondary[50]};
          color: ${theme.palette.grey[900]};
        }
      `;
      break;
    }
    case "error": {
      colorStyles += `
        &&& {
          background-color: ${theme.palette.error[50]};
          color: ${theme.palette.grey[800]};
        }
      `;
      break;
    }
  }
  return colorStyles;
});
const StyledSubtitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "colorVariant"
})`
  ${({ colorVariant }) => {
  switch (colorVariant) {
    case "grey": {
      return css`
          &&& {
            text-decoration: line-through;
          }
        `;
    }
    default:
      return "";
  }
}}
`;
const StyledMuiDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== "initialPosition"
})`
  .${dialogClasses.container} {
    justify-content: ${({ initialPosition }) => initialPosition ? "flex-start" : "center"};
    align-items: ${({ initialPosition }) => initialPosition ? "flex-start" : "center"};
  }
`;
export {
  HeaderTextWrapper,
  StyledDialogTitle,
  StyledMuiDialog,
  StyledSubtitle,
  Wrapper
};
